import { useEffect, useState } from 'react';
import { Row, Col, InputGroup, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from '../../../Auth/apiService';
import CargandoSpinner from "../../Utils/CargandoSpinner";
import SeccionPageHeader from "../../Utils/SeccionPageHeader";
import { useAuth } from '../../../Auth/AuthContext';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import { Watch } from '@mui/icons-material';

export default function ValoresAyudas() {
    const { token, user } = useAuth();
    const [cargando, setCargando] = useState(false);
    const [valoresAyudas, setValoresAyudas] = useState([]);
    const [swalProps, setSwalProps] = useState({})
    const { handleSubmit, register, watch, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [tiposAhu, setTiposAhu] = useState([]);
    const [tiposEntrega, setTiposEntrega] = useState([]);
    const [ayudas, setAyudas] = useState([]);
    function MostrarFormulario(row) {
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('usrid', user);
        setValue('tip_tipoahu', row.ayu_tipoahuid);
        setValue('tip_tipoentrega', row.ayu_tipoentregaid);
        setValue('ayu_ayuda', row.ayu_ayudaid);
        setValue('ayu_valor', row.ayu_valor);
    }
    function editarAyuda(row) {
        return (
            <Button
            variant="warning"
            size="sm"
            onClick={() => {
                MostrarFormulario(row);
            }}
        >
            Editar
        </Button>
        )
    }
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/bodega/guardarayudavalor';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data.message));
                ResetForm();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data.message));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ConsultarValores();
        }
    };
    const Eliminar = async (id) => {
        if (id === '0') {
            Mensaje('Eliminar', 'Debe seleccionar un registro para eliminar');
            return;
        }
        setCargando(true);
        const url = '/bodega/eliminarayudavalor';
        try {
            const response = await apiService.post(url, { id }, token);
            if(response.status === 200){
                Mensaje('Eliminar', JSON.stringify(response.data.message));
                ResetForm();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Eliminar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Eliminar', JSON.stringify(error.response.data.message));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            ConsultarValores();
        }
    };
    const ResetForm = () => {
        setMuestraFormulario(false);    
        setValue('id', '0');
        setValue('usrid', user);    
        setValue('tip_tipoahu', '');
        setValue('tip_tipoentrega', '');        
        setValue('ayu_ayuda', '');
        setValue('ayu_valor', '');
    };
    const columns = [
        {
            name: 'Editar',
            cell: row => editarAyuda(row),
            ignoreRowClick: true,
            allowoverflow: true,
            width: '8%',
        },
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            width: '7%',
        },
        {
            name: 'Tipo AH',
            selector: row => row.tip_tipoahu,
            sortable: true,
            width: '40%',
            format: row => row.tip_tipoahu,
        },
        {
            name: 'Tipo entrega',
            selector: row => row.tip_tipoentrega,
            sortable: true,
            width: '10%',
        },
        {
            name: 'Ayuda',
            selector: row => row.ayu_ayuda,
            sortable: true,
            width: '20%',
        },
        {
            name: 'Valor',
            selector: row => row.ayu_valor,
            sortable: true,
            width: '20%',
        }
    ];
    const exportarValoresExcel = () => {
        if (!valoresAyudas || valoresAyudas.length === 0) return;
        const worksheet = XLSX.utils.json_to_sheet(valoresAyudas);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "BodegaValoresAyudas");
        XLSX.writeFile(workbook, "valores_ayuds_bodega.xlsx", { bookType: "xlsx" });
    };
    function InicilizarFormulario(){
        const url = '/bodega/inicializarformvaloresayudas';
        apiService.get(url, token)
            .then((response) => {
                const data = response.data;
                setTiposAhu(data.tiposAyu);
                setTiposEntrega(data.tiposEntrega);
                setAyudas(data.ayudas);
            })
            .catch((error) => {
                console.error('Error fetching initial data:', error);
            });
    }
    const ConsultarValores = async () => {
        const url = '/bodega/consultarayudasvalores';
        try {
            setCargando(true);
            const response = await apiService.post(url, {}, token);
            const result = await response.data;
            if(result.valoresAyudas){
                setValoresAyudas(result.valoresAyudas);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    useEffect(() => {
        InicilizarFormulario();
        ConsultarValores();
    }, [token]);
    return (
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Ayudas y valores"
                idCabezaFamilia="1"
                url="/bodega/ahe"
                nombreurl="AHE"
                nombreform="Ayudas y valores"
            />
            <CargandoSpinner Cargando={cargando} />
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario comunas</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <Row>
                                        <Col md={1}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>Id</InputGroup.Text>
                                                    <input id='id' disabled className='form-control' {...register('id')}/>
                                                    <input id='usrid' hidden className='form-control' {...register('usrid')}/>
                                            </InputGroup>
                                        </Col>
                                        <Col md={6}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>Tipo AH</InputGroup.Text>
                                                <select
                                                    className={`form-control ${errors.tip_tipoahu ? 'is-invalid' : ''}`}
                                                    {...register('tip_tipoahu', { required: true })}
                                                >
                                                    <option value="">Seleccione tipo AH</option>
                                                    {tiposAhu.map(opt => (
                                                        <option key={opt.id} value={opt.id}>{opt.tip_tipoahu}</option>
                                                    ))}
                                                </select>
                                                {errors.tip_tipoahu && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                            </InputGroup>
                                        </Col>
                                        <Col md={6}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>Tipo entrega</InputGroup.Text>
                                                <select
                                                    className={`form-control ${errors.tip_tipoentrega ? 'is-invalid' : ''}`}
                                                    {...register('tip_tipoentrega', { required: true })}
                                                >
                                                    <option value="">Seleccione tipo entrega</option>
                                                    {tiposEntrega.map(opt => (
                                                        <option key={opt.id} value={opt.id}>{opt.tip_tipoentrega}</option>
                                                    ))}
                                                </select>
                                                {errors.tip_tipoentrega && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                            </InputGroup>
                                        </Col>
                                        <Col md={6}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>Ayuda</InputGroup.Text>
                                                <select
                                                    className={`form-control ${errors.ayu_ayuda ? 'is-invalid' : ''}`}
                                                    {...register('ayu_ayuda', { required: true })}
                                                >
                                                    <option value="">Seleccione ayuda</option>
                                                    {ayudas.map(opt => (
                                                        <option key={opt.id} value={opt.id}>{opt.ayu_ayuda}</option>
                                                    ))}
                                                </select>
                                                {errors.ayu_ayuda && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                            </InputGroup>
                                        </Col>
                                        <Col md={6}>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>Valor</InputGroup.Text>
                                                <input
                                                    type="number"
                                                    className={`form-control ${errors.ayu_valor ? 'is-invalid' : ''}`}
                                                    {...register('ayu_valor', { required: true })}
                                                />
                                                {errors.ayu_valor && <div className="invalid-feedback">Este campo es obligatorio</div>}
                                            </InputGroup>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="card-footer">
                                    <Row>
                                        <Col md={1}>
                                            <Button type="submit" variant="primary" disabled={cargando}>
                                                Guardar
                                            </Button>
                                        </Col>
                                        {watch('id') !== '0' && <Col md={1}>
                                            <Button variant="danger" onClick={() => Eliminar(watch('id'))}>
                                                Eliminar
                                            </Button>
                                        </Col>}
                                    </Row>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary card-outline">
                                <div className="card-header">
                                    <h3 className="card-title">Ayudas y valores ahe</h3>
                                </div>
                                <div className="card-body">
                                    <Button variant="success" onClick={exportarValoresExcel} className="mb-2 me-2">
                                        Exportar CSV
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="mb-2 me-2"
                                        onClick={() => {
                                            setMuestraFormulario(true);
                                            setValue('id', '0');
                                            setValue('usrid', user);
                                            setValue('tip_tipoahu', '');
                                            setValue('tip_tipoentrega', '');
                                            setValue('ayu_ayuda', '');
                                            setValue('ayu_valor', '');
                                        }}
                                    >
                                        Nuevo
                                    </Button>
                                    <DataTable
                                        columns={columns}
                                        data={valoresAyudas}
                                        pagination
                                        highlightOnHover
                                        dense
                                        noDataComponent="No hay valores para mostrar"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAResultado();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>  
            </section>
        </div>
    );

}